import { Outlet } from "react-router-dom";
import { GlobalLayout, Breadcrumbs } from "@/shell";
import { BreadcrumbProvider } from "@/shell/BreadcrumbContext";
import { useBreadcrumbContext } from "@/shell/useBreadcrumbContext";
import { RequireAuth } from "@/auth/RequireAuth";

function ShellWithBreadcrumbs() {
  const { items } = useBreadcrumbContext();
  return (
    <GlobalLayout breadcrumbs={<Breadcrumbs items={items} />}>
      <Outlet />
    </GlobalLayout>
  );
}

/** Authenticated application route layout. */
export function AppShellLayout() {
  return (
    <RequireAuth>
      <BreadcrumbProvider>
        <ShellWithBreadcrumbs />
      </BreadcrumbProvider>
    </RequireAuth>
  );
}

export { AppShellLayout as RouteLayout };
